import type { QueryFunctionContext } from "@tanstack/query-core"
import type { AxiosResponse } from "axios"

import { axiosClient } from "$/http"

import { ECoachingChatQueryKeyBase as EQueryKeyBase, ECoachingChatApiQueryUrl as EUrl } from "../../config"
import type {
    ICoachingChatConversationQueryDto as IConversationDto,
    ICoachingChatDisclaimerQueryDto as IDisclaimerQueryDto,
    ICoachingChatNewMessagesQueryDto as INewMessagesDto
} from "../../types"

async function conversationFetcher({
    queryKey
}: QueryFunctionContext<[EQueryKeyBase, number]>): Promise<IConversationDto> {
    const [, id]: [EQueryKeyBase, number] = queryKey

    const { data }: AxiosResponse<IConversationDto> = await axiosClient.get(EUrl.GetConversation(id))

    return data
}

async function newMessagesFetcher({
    queryKey
}: QueryFunctionContext<[EQueryKeyBase, number]>): Promise<INewMessagesDto> {
    const [, id]: [EQueryKeyBase, number] = queryKey

    const { data }: AxiosResponse<INewMessagesDto> = await axiosClient.get(EUrl.GetConversationNewMessages(id))

    return data
}

async function legaliseFetcher(): Promise<IDisclaimerQueryDto> {
    const { data }: AxiosResponse<IDisclaimerQueryDto> = await axiosClient.get(EUrl.CoachingChatDisclaimer())

    return data
}

const fetchers = { conversationFetcher, newMessagesFetcher, legaliseFetcher }

export { fetchers as coachingChatQueriesFetchers }
